// @owners { team: patient-health }
import { getAddress } from '~shared/features/addresses/selectors/getAddress';
import { getNextUpcomingDeliveryForPrescription } from '~shared/features/delivery/selectors/getUpcomingDeliveriesForPrescription';
import { getIsFertilityUser } from '~shared/features/users/selectors/getIsFertilityUser';
import { connect } from '~shared/store';
import { type ReduxStateShared } from '~shared/types';
import { Prescription } from './Prescription';

// @ts-expect-error TS(7006): Parameter 'state' implicitly has an 'any' type.
function mapStateToProps(state: ReduxStateShared, ownProps) {
  // The upcoming delivery is retrieved here rather than receiving it as a prop from MedListRow because the
  // upcoming delivery for MedListRow is based on the med's representative prescription. This breaks where a med has
  // multiple active prescriptions, in which case there can be a separate delivery for each active prescription.
  const upcomingDelivery = getNextUpcomingDeliveryForPrescription(state, {
    prescription: ownProps.prescription,
  });

  return {
    upcomingDelivery,
    address: getAddress(state, { addressID: upcomingDelivery?.address_id }),
    isFertilityUser: getIsFertilityUser(state, {
      userID: ownProps.prescription.user_id,
    }),
  };
}

export default connect(mapStateToProps)(Prescription);
